"use client";
import Image from "next/image";
import Link from "next/link";
import { FC, useState } from "react";
import { ButtonBurger } from "./common/Buttons";

const TITLES = [
	{ title: "Main", href: "/#Main" },
	{ title: "About", href: "/#About" },
	{ title: "App", href: "/#App" },
	{ title: "FAQ", href: "/faq" },
	{ title: "Contact", href: "/#Contact" },
];

type Props = {};

const Header: FC<Props> = () => {
	const [menuIsOpen, setMenuIsOpen] = useState(false);
	const toggleMenu = () => {
		setMenuIsOpen(!menuIsOpen);
	};
	return (
		<div className=' fixed z-50 w-full h-[74px] bg-main  flex items-center justify-between py-[6px] px-[80px] max-desktop:px-[32px] max-tablet:px-[16px]'>
			{/* Logos */}
			<Link href={"/"} prefetch={false}>
				<img
					className='cursor-pointer w-[165px] h-[62px] max-desktop:hidden'
					src='/icons/logo.png'
					width={500}
					height={110}
					alt='Logo'
				/>
				<img
					className='cursor-pointer hidden max-desktop:block w-[125px] '
					src='/icons/logo.png'
					width={600}
					height={410}
					alt='Logo'
				/>
			</Link>
			{/* Menu titles */}
			<div className='flex gap-[40px] max-tablet:hidden mx-auto'>
				{TITLES.map((el, index) => (
					<Link
						key={index}
						href={el.href}
						prefetch={false}
						style={{ all: "unset" }}
					>
						<p className='text-[18px] max-desktop:text-[16px] font-[500] text-white cursor-pointer hover:underline transition-all duration-300 ease-in-out'>
							{el.title}
						</p>
					</Link>
				))}
			</div>
			<ButtonBurger menuIsOpen={menuIsOpen} toggle={toggleMenu} />

			{/* Button */}
			<div className='w-[151px] h-[45px] max-desktop:w-[121px] max-desktop:h-[36px] rounded-[15px] bg-white text-black hover:text-white flex items-center justify-center cursor-pointer hover:border-white border-2 hover:bg-main transition-all duration-300 ease-in-out'>
				<Link href="/#App" prefetch={false} style={{ all: "unset" }}>
					<p className='text-[18px] max-desktop:text-[14px] font-[500]'>
						Try for free
					</p>
				</Link>

			</div>

			<div
				className={`absolute z-20 w-full py-[20px] bg-main top-[74px] ${
					menuIsOpen ? "menuopen" : "hidden"
				}  left-0`}>
				{TITLES.map((el, index) => (
					<Link href={el.href} key={index} prefetch={false}>
						<p
							onClick={toggleMenu}
							className='text-[20px] text-center cursor-pointer'>
							{el.title}
						</p>
					</Link>
				))}
			</div>

			<></>
		</div>
	);
};

export default Header;
